import { Injectable } from '@angular/core'
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { catchError, throwError } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { FormBuilder, FormArray } from '@angular/forms'

@Injectable({
  providedIn: 'root'
})
export class PizarraService {

  constructor(
    private http: HttpClient,
    private fb:FormBuilder, 
  ) {}

  pizarra = this.fb.group({
    name: [''],
    pizarra: this.fb.control<any | null>(null),
  })

  readonly baseURL = environment.DOMAIN_URL+'/api/pizarra/'

  get(){
    return this.http.get(this.baseURL)
    .pipe(catchError(this.errorHandler))
  }

  save(pizarra:HTMLElement[]){
    const elementosHTML = pizarra.map(element => element.outerHTML)
    this.pizarra.get('pizarra')?.setValue(elementosHTML)
    return this.http.post(this.baseURL, {pizarra: this.pizarra.getRawValue()})
    .pipe(catchError(this.errorHandler))
  }

  remove(id:string){
    return this.http.delete(this.baseURL+id)
    .pipe(catchError(this.errorHandler))
  }

  private errorHandler(error: HttpErrorResponse) {
    if (error.status === 0) console.error('An error occurred:', error.error)
    else console.error(`Backend returned code ${error.status}, body was: `, error.error)
    return throwError(() => new Error('Something bad happened; please try again later.'))
  }
}
